import { formatTimeToCY } from '../../../utils';

export const INPUT_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';

export const formatTradingActivityDate = (value?: string | null): string =>
  formatTimeToCY(value, undefined, INPUT_DATE_FORMAT);
